import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_OUTLINE_BUTTONS, FLAT_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatOutlineButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineButton} span={FLAT_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn outline color="primary" id="Tooltip-40" className="btn-square">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-40" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-outline-primary</ToolTip>
          {FLAT_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonFlateButton key={index} item={data} outline={true}/>
          ))}
        </CardBody>
      </Card>
    );
};

export default FlatOutlineButtons;
